import { ApiQueryParams } from '@frontend/api-utils';
import { AttributeClient } from '@frontend/attribute/api';
import { Attribute, AttributeQueryParams } from '@frontend/attribute/types';
import { Spinner } from '@frontend/elements';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { getCorrectTranslation, useLocale } from '@frontend/lang';
import React, { useState } from 'react';

const ID = 'attribute-select';
export interface AttributeSelectProps extends ObjectSelectV2Props<Attribute, AttributeQueryParams> {
    id?: string;
    accountId?: string;
    label?: React.ReactNode;
    required?: boolean;
    submitted?: boolean;
    onChange?: (newValue: string | null) => void;
    onChangeObject?: (newValue: Attribute | null) => void;
    value?: string | null;
    className?: string;
    disabled?: boolean;
    useConditionedStyling?: boolean;
    isClearable?: boolean;
    allowURLChange?: boolean;
    createEnabled?: boolean;
    queryParams?: ApiQueryParams<AttributeQueryParams>;
    subset?: string[];
}
/**
 * @deprecated
 */
export const AttributeSelect = (props: AttributeSelectProps) => {
    const { locale } = useLocale();
    const [q, cQ] = useState<Attribute | null>(null);

    if (!locale) return <Spinner />;
    return (
        <ObjectSelectInputV2<Attribute, AttributeQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Attribute'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cQ(v);
            }}
            disabled={props.disabled}
            required={props.required}
            queryParams={props.queryParams}
            value={q}
            idValue={props.value || q?.id}
            fetch={(arg) => AttributeClient.fetchAttributes({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(o) => getCorrectTranslation(locale, o, 'name')}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'category_id',
                          fetch: (pathParam) => AttributeClient.fetchAttribute(props.accountId!, pathParam)
                      }
                    : undefined
            }
            isClearable={props.isClearable}
            subset={props.subset}
        />
    );
};
